import React, { useState, useEffect } from 'react';
import EnterprisesForm from 'shared/forms/EnterprisesForm';
import Layout from 'shared/component/Layout';
import { useEnterprise } from 'hook/enterprise';
import { useParams } from 'react-router-dom';
import { useStyles, ScreenContainer } from './styles';
import { CircularProgress } from '@material-ui/core';

export default function EnterpriseUpdatePage() {
  const classes = useStyles();
  const { id } = useParams();
  const { data, loading, getOne, getUpdate, status } = useEnterprise();
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (id !== ':id') {
      getOne({ id });
    }
  }, []);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      setTimeout(() => {
        setInitialValues(data);
      }, 500);
    }
  }, [data]);

  const formSubmit = (data) => {
    getUpdate({ id, data });
  };

  return (
    <Layout title="Empresas" showToday backArrow>
      <ScreenContainer>
        {initialValues ? (
          <EnterprisesForm
            formInitialValues={initialValues}
            loading={loading}
            formSubmit={formSubmit}
            status={status}
            isEdit
          />
        ) : (
          <div className={classes.loading_container}>
            <CircularProgress color="primary" size={50} />
          </div>
        )}
      </ScreenContainer>
    </Layout>
  );
}
